import { Result } from 'antd';
import styled from 'styled-components';
import { type MaintenanceSettings } from '../../pages/portal/Maintenance';
import useTranslatedString from '../../utilities/useTranslatedString';
import Image from '../Image';

const StyledResult = styled(Result)`
    & .ant-result-subtitle {
        color: #000;
    }
    &.no-icon .ant-result-icon {
        display: none;
    }
`;

const MaintenanceResult = ({ maintenance }: { maintenance: MaintenanceSettings }) => {
    const translateString = useTranslatedString();

    const { image, pageTitle, pageContent } = maintenance;
    const icon = image?.url ? <Image preview={false} src={image.url} /> : null;
    const className = icon ? null : 'no-icon';

    return (
        <StyledResult
            className={className}
            icon={icon}
            subTitle={translateString(pageContent)}
            title={translateString(pageTitle)}
        />
    );
};

export default MaintenanceResult;
